import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, TextField, Typography } from "@material-ui/core";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import React, { useState, useEffect } from "react";
import { globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus } from "../../../utils_v2";
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import { PageLoader } from "../../../shared_elements";
import { Autocomplete } from "@material-ui/lab";

const AddEditAssetStatus = ({ toggleModalFn, assetStatusCRU, getResponseBack, modeType, assetStatusInfo }) => {
    const [data, setData] = useState(assetStatusCRU?.data);
    const [error, setError] = useState({ modal: false, data: null })
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const initSubStatuses = () => {
        const existing = assetStatusCRU?.data?.sub_statuses;
        if (Array.isArray(existing) && existing.length) return existing.map(s => (typeof s === 'object' ? s?.sub_status || s?.name || '' : s));
        if (typeof existing === 'string' && existing.trim()) return [existing];
        return [''];
    };
    const [subStatuses, setSubStatuses] = useState(initSubStatuses);

    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value })
    }
    const onAddEditAssetStatus = () => {
        let validationInputs = {
            ownership: data?.ownership ? '' : 'Please select Ownership',
            asset_status: data?.asset_status?.trim() ? '' : 'Please enter Asset Status',
            contract_statuses: data?.contract_statuses?.length ? '' : 'Please select Contract Status',
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            let payload = Object.assign({}, data);
            payload = {
                ...payload,
                ownership: payload?.ownership ? payload?.ownership : null,
                asset_status: payload?.asset_status ? payload?.asset_status : null,
                remarks: payload?.remarks ? payload?.remarks : null,
                sub_statuses: subStatuses.filter(s => s.trim()),
                contract_statuses: (payload?.contract_statuses || [])?.map(cs => typeof cs === 'object' ? cs?.contract_status || '' : cs)?.filter(Boolean),
            }
            const apiUrl = data?.id ? `config-data/asset-status/${data?.id}/` : `config-data/asset-status/`;
            const apiMethod = data?.id ? globalPutService : globalPostService;
            apiMethod(apiUrl, payload).then((response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        toggleModalFn();
                        getResponseBack();
                        setLoading(false)
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Asset Status Updated Successfully' : 'Asset Status Added Successfully',
                            page_title: 'Config Data : Asset Status',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            updated_id: data?.id || null,
                            success_msg: response?.data?.message
                        })
                    } else {
                        getResponseBack();
                        setError({ modal: true, data: response?.data?.error_details })
                        setLoading(false)
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Asset Status Updation Failed' : 'Asset Status Added Failed',
                            page_title: 'Config Data : Asset Status',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            item_id: data?.id || null,
                            error_msg: response?.data?.message
                        })
                    }
                })
        } else {
            setError(validationInputs);
        }
    }

    return (
        <>
            <Dialog
                open={true}
                className='console-management-modal'
            >
                <DialogTitle id="scroll-dialog-title">
                    {modeType === 'edit' ? 'Edit' : modeType === 'view' ? 'Veiw' : 'Add'} Asset Status
                </DialogTitle>
                <DialogContent dividers>
                    <div>
                        <Grid container spacing={1}>
                            <Grid item md={6} sm={6} xs={12}>
                                <Autocomplete
                                    options={["Owned", "Managed","Third Party"]}
                                    getOptionLabel={option => option || ''}
                                    id="ownership"
                                    disabled={modeType === 'view'}
                                    value={data?.ownership || null}
                                    onChange={(e, value) => onFieldChange('ownership', value)}
                                    renderInput={params => <TextField placeholder={'Please select ownership'} {...params} label={'Ownership'} error={!!error?.ownership} helperText={error?.ownership || ''} margin="normal" required fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    onFocus={() => setError({ ...error, ownership: '' })}
                                />
                            </Grid>
                            <Grid item md={6} sm={6} xs={12}>
                                <TextField
                                    required
                                    name='asset_status'
                                    label='Asset Status'
                                    disabled={modeType === 'view'}
                                    value={data?.asset_status || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    error={!!error?.asset_status}
                                    helperText={error?.asset_status || ''}
                                    onChange={(e) => onFieldChange('asset_status', e.target.value)}
                                    onFocus={() => setError({ ...error, asset_status: '' })}
                                />
                            </Grid>
                            <Grid item md={12} sm={12} xs={12}>
                                <Typography variant="caption" style={{ color: '#7a7a7a', fontWeight: 600, letterSpacing: 1, textTransform: 'uppercase' }}>
                                    Sub Status(es)
                                </Typography>
                                {subStatuses?.map((val, index) => (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <TextField
                                            value={val}
                                            placeholder={index === 0 ? 'e.g. Active Lease' : 'e.g. In Storage'}
                                            fullWidth
                                            margin="dense"
                                            InputLabelProps={{ shrink: true }}
                                            variant='outlined'
                                            disabled={modeType === 'view'}
                                            onChange={(e) => {
                                                const updated = [...subStatuses];
                                                updated[index] = e.target.value;
                                                setSubStatuses(updated);
                                            }}
                                        />
                                        {modeType !== 'view' && (
                                            <IconButton
                                                size="small"
                                                onClick={() => setSubStatuses(subStatuses.filter((_, i) => i !== index))}
                                                style={{ color: '#d32f2f', flexShrink: 0 }}
                                            >
                                                <RemoveCircleOutlineIcon />
                                            </IconButton>
                                        )}
                                    </div>
                                ))}
                                {modeType !== 'view' && (
                                    <Button
                                        color="primary"
                                        size="small"
                                        style={{ marginTop: 4, textTransform: 'none', fontWeight: 600 }}
                                        onClick={() => setSubStatuses([...subStatuses, ''])}
                                    >
                                        + Add Status
                                    </Button>
                                )}
                            </Grid>
                            <Grid item md={12} sm={12} xs={12}>
                                <Autocomplete
                                    options={["Active","On Hold","Terminated","Closed"]}
                                    getOptionLabel={option => (typeof option === 'object' ? option?.contract_status || '' : option) || ''}
                                    id="contract_statuses"
                                    disabled={modeType === 'view'}
                                    multiple={true}
                                    value={(data?.contract_statuses || []).map(cs => typeof cs === 'object' ? cs?.contract_status || '' : cs)}
                                    onChange={(e, value) => onFieldChange('contract_statuses', value)}
                                    renderInput={params => <TextField required placeholder={'Please select Contract Statuses'} {...params} label={'Contract Status'} error={!!error?.contract_statuses} helperText={error?.contract_statuses || ''} margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    onFocus={() => setError({ ...error, contract_statuses: '' })}
                                />
                            </Grid>
                            <Grid item md={12} sm={12} xs={12}>
                                <TextField
                                    name='remarks'
                                    label='Remarks'
                                    disabled={modeType === 'view'}
                                    value={data?.remarks || ''}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    rows={2}
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('remarks', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Config Data : Asset Status', item_type: 'Cancel Button', event_type: 'Item Clicked', event_desc: `Clicked on Cancel Button from ${modeType === 'add' ? 'Add' : modeType === 'view' ? 'View' : 'Edit'} Asset Status form` }) }} color='primary' size='small' variant='outlined'>Cancel</Button>
                    {modeType === 'view' ? null :
                        <Button
                            onClick={() => {
                                onAddEditAssetStatus();
                                trackActivity('Console Management', { page_title: 'Config Data : Asset Status', item_type: 'Save Button ', event_type: 'Item Clicked', event_desc: `Clicked on Save Button from ${modeType === 'add' ? 'Add' : 'Edit'} Asset Status form` })
                            }}
                            disabled={isLoading}
                            color='primary'
                            size='small'
                            variant='contained'>
                            {isLoading ? <CircularProgress size={24} /> : 'Save'}
                        </Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default AddEditAssetStatus